import {keyframes} from "styled-components";

export const popRise = keyframes`
  0% { opacity: 0; transform: translateY(6px); }
  20% { opacity: 1; transform: translateY(0); }
  80% { opacity: 1; }
  100% { opacity: 0; transform: translateY(-12px); }
`;

export const pulse = keyframes`
  0%, 100% { transform: translate(-50%, -50%) scale(1); box-shadow: 0 4px 10px rgba(15, 23, 42, 0.08); }
  50% { transform: translate(-50%, -50%) scale(1.03); box-shadow: 0 6px 16px rgba(34, 197, 94, 0.25); }
`;
